let searchInput = document.getElementById("accordionSearch");
let noResults = document.getElementById("noResults");
var accordion_list = [];

document.querySelectorAll(".tab-title").forEach((head) => {
  let first = head.dataset.first;
  document.querySelectorAll(`.${first}`).forEach((ele) => ele.classList.add("active-tab-content"));
  head.addEventListener("click", (event) => {
    let tabId = head.dataset.tab;
    const searchContainer = document.querySelector('.accordion-wrapper__container .search-container');
    if (tabId === 'all') {
      searchContainer.classList.remove("hidden");
    } else {
      searchContainer.classList.add("hidden");
      searchInput.value = '';
      searchResults();
    }
    document.querySelectorAll(".tab-title").forEach((h) => h.classList.remove("active-tab"));
    document.querySelectorAll(".accordion-container").forEach((c) => c.classList.remove("active-tab-content"));
    head.classList.add("active-tab");
    document.querySelectorAll(`.${tabId}`).forEach((ele) => ele.classList.add("active-tab-content"));
  });
});

searchInput?.addEventListener("keyup", function (event) { 
  searchResults(event);
});

function searchResults() {
  let searchQuery = searchInput.value.toLowerCase();
  let accordion = document.querySelectorAll(".accordion-details .summary__text");
  let accordionAnswer = document.querySelectorAll('.accordion-description p');
  
  for (let i = 0; i < accordion.length; i++) {
  const currentName = accordion[i].textContent.toLowerCase();
  const currentAnswer = accordionAnswer[i].textContent.toLowerCase();

  if (currentName.includes(searchQuery) || currentAnswer.includes(searchQuery)) {
    accordion[i].closest('.accordion-details').style.display = "block";
  } else {
    accordion[i].closest('.accordion-details').style.display = "none";
  }

    let obj = {};
    obj.accordion_title = currentName;
    obj.accordion_answer = currentAnswer;
    accordion_list.push(obj);

    var filteredList = accordion_list.filter(function (arr) {
      return arr.accordion_title.includes(searchQuery);
    });

    var filteredList = accordion_list.filter(function (arr) {
      return arr.accordion_answer.includes(searchQuery);
    });

    if (filteredList.length === 0) {
      noResults.innerHTML = "No Results Found";
    } else {
      noResults.innerHTML = "";
    }
  }
}

